/**
 * Accessibility wrapper for the Appikon "Back in Stock" widget.
 * The app renders #BIS_frame as a full-viewport, same-origin iframe and toggles
 * it with display:block/none. It ships no Escape handler, no focus management,
 * and an unfocusable close control. This wraps it from the host page. */

(function () {
  const FRAME_ID = 'BIS_frame'
  const TRIGGER_ID = 'BIS_trigger'
  let inerted = []
  let invoker = null
  let lastTrigger = null
  let wired = false

  // The PDP and the mobile sticky bar each have a #BIS_trigger (the app finds its trigger by that ID), so
  // getElementById can return the wrong one. Remember the copy that was actually used.
  const triggers = () => document.querySelectorAll(`[id="${TRIGGER_ID}"]`)
  document.addEventListener(
    'click',
    e => {
      const t = e.target.closest?.(`[id="${TRIGGER_ID}"]`)
      if (t) lastTrigger = t
    },
    true
  )

  const frame = () => document.getElementById(FRAME_ID)
  const isOpen = () => {
    const f = frame()
    return !!f && getComputedStyle(f).display !== 'none'
  }

  const closeControl = () => {
    const d = frame()?.contentDocument
    if (!d) return null
    return [...d.querySelectorAll('[aria-label]')].find(e => /close dialog/i.test(e.getAttribute('aria-label')))
  }

  function enhanceFrame() {
    const f = frame()
    if (!f) return
    if (!f.getAttribute('title')) f.setAttribute('title', 'Back in stock notification')

    const d = f.contentDocument
    if (!d) return
    if (!d.title) d.title = 'Back in stock notification'
    if (!d.documentElement.getAttribute('lang')) {
      d.documentElement.setAttribute('lang', document.documentElement.lang || 'en')
    }

    const c = closeControl()
    if (c && c.tabIndex < 0) c.setAttribute('tabindex', '0')
    if (c && !c.dataset.a11yKeys) {
      c.dataset.a11yKeys = '1'
      c.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          c.click()
        }
      })
    }

    if (!d.__bisEscBound) {
      d.__bisEscBound = true
      d.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
          e.preventDefault()
          doClose()
        }
      })
    }
  }

  function inertBackground() {
    const f = frame()
    ;[...document.body.children].forEach(el => {
      if (el === f || el.hasAttribute('inert')) return
      el.setAttribute('inert', '')
      inerted.push(el)
    })
  }

  function restoreBackground() {
    inerted.forEach(el => el.removeAttribute('inert'))
    inerted = []
  }

  function doClose() {
    const c = closeControl()
    if (c) c.click()
    else {
      const f = frame()
      if (f) f.style.display = 'none'
    }
  }

  function onOpen() {
    invoker = lastTrigger?.isConnected ? lastTrigger : document.getElementById(TRIGGER_ID)
    invoker?.setAttribute('aria-expanded', 'true')
    enhanceFrame()
    inertBackground()
    const d = frame()?.contentDocument
    ;(d?.querySelector('select, input, button') || frame())?.focus()
  }

  function onClose() {
    restoreBackground()
    invoker?.setAttribute('aria-expanded', 'false')
    if (invoker?.isConnected) requestAnimationFrame(() => invoker.focus())
  }

  function wire() {
    const f = frame()
    if (!f || wired) return
    wired = true

    triggers().forEach(t => {
      t.setAttribute('aria-haspopup', 'dialog')
      t.setAttribute('aria-controls', FRAME_ID)
      if (!t.hasAttribute('aria-expanded')) t.setAttribute('aria-expanded', 'false')
    })

    let was = isOpen()
    new MutationObserver(() => {
      const now = isOpen()
      if (now !== was) {
        was = now
        now ? onOpen() : onClose()
      } else if (now) {
        enhanceFrame()
      }
    }).observe(f, { attributes: true, attributeFilter: ['style', 'class'] })

    f.addEventListener('load', () => {
      if (isOpen()) enhanceFrame()
    })

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && isOpen()) {
        e.preventDefault()
        doClose()
      }
    })

    if (isOpen()) onOpen()
  }

  const iv = setInterval(() => {
    if (frame()) {
      clearInterval(iv)
      wire()
    }
  }, 200)
  setTimeout(() => clearInterval(iv), 15000)
})()